"use client";

import Link from "next/link";
import { useState, useEffect } from "react";

interface QuickNavCategory {
  slug: string;
  label: string;
}

const quickNavSlugs: QuickNavCategory[] = [
  { slug: "outillage-pro", label: "Outillage" },
  { slug: "energie-air", label: "Énergie et air" },
  { slug: "plomberie-soudure-couverture", label: "Plomberie, soudure et couverture" },
  { slug: "sablage-nettoyage-jardinage", label: "Sablage, nettoyage, jardinage" },
  { slug: "sol-mur-beton", label: "Sol, mur, béton" },
  { slug: "terrassement-compactage", label: "Terrassement, compactage" },
];

export function QuickNavSection() {
  const [icons, setIcons] = useState<Record<string, string>>({});

  useEffect(() => {
    const slugs = quickNavSlugs.map((c) => c.slug).join(",");
    fetch(`/api/categories/icons?slugs=${slugs}`)
      .then((r) => r.ok ? r.json() : {})
      .then((data) => setIcons(data))
      .catch(() => {});
  }, []);

  return (
    <div className="bg-white border-b border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-1 py-2 overflow-x-auto scrollbar-hide">
          {quickNavSlugs.map((item) => (
            <Link
              key={item.slug}
              href={`/categories/${item.slug}`}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm text-gray-600 hover:bg-secondary/10 hover:text-secondary whitespace-nowrap transition-colors flex-shrink-0"
            >
              {icons[item.slug] ? (
                <img
                  src={icons[item.slug]}
                  alt=""
                  className="w-4 h-4 object-contain"
                />
              ) : (
                <span className="w-4 h-4" />
              )}
              <span>{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
